<template>
  <div class="md-layout ">
    <div class="md-layout-item md-size-85">
      <h1 class="md-display-1">Список пользователей</h1>
    </div>
    <div class="md-layout-item md-size-10">
      <md-button class="ct-green" v-on:click="addUser">Создать пользователя</md-button>
    </div>
    <UsersCreate
    :key="keyCreateUser+'userCreate'"
    :openCreateDialog="openCreateUser"
    @closeCreateDialog="closeUserCreate()"
    @closeCreateDialogSuccess="closeUserCreate(true)"
    ></UsersCreate>
    <UsersFilter v-on:changeUsersFilter="changeUsersFilter"/>
    <UsersTable :key="keyTable" v-on:editUser="editUser"/>
    <UsersEdit :key="keyDialog+'EditUserDialog'" :openDialog="openDialog" @closeDialogSuccess="closeEditDialog(true)" @closeDialog="closeEditDialog()"/>
  </div>
</template>

<script>
import Vuex from 'vuex'
import store from '@/store'
import UsersFilter from './UsersFilter'
import UsersTable from './UsersTable'
import UsersEdit from './UsersEdit'
import UsersCreate from './UsersCreate'

const userFilter = new Vuex.Store({
  state: {
    filtersUsers: {
      q: null,
      country_code: store.getters.regionUser
      // shop_id: null,
      // user_id: null
    },
    filtersShop: {
      q: null,
      country_code: store.getters.regionUser
      // shop_id: null,
      // user_id: null
    },
    search: '',
    editId: null,
    shopId: null,
    roles: {
      // '1': 'Администратор',
      '2': 'Директор',
      // '3': 'Оператор приёмки',
      // '4': 'Ответственный за Складской учёт',
      '5': 'Администратор компании',
      '6': 'Кассир'
    }
  },
  mutations: {
    setFilter (obj, result) {
      if (result['value'] === 'deleteFilter') {
        this.state.filtersShop[result['name']] = null
      } else {
        this.state.filtersShop[result['name']] = result['value']
      }
    },
    setUsersFilter (obj, result) {
      if (result['value'] === 'deleteFilter') {
        this.state.filtersUsers[result['name']] = null
      } else {
        this.state.filtersUsers[result['name']] = result['value']
      }
    }
  }
})

export default {
  data () {
    return {
      showTable: 1,
      filter: {},
      keyTable: 1,
      keyDialog: 1,
      openDialog: 0,
      keyCreateUser: 1,
      openCreateUser: 0
    }
  },
  name: 'UsersIndex',
  components: { UsersEdit, UsersTable, UsersFilter, UsersCreate },
  store: userFilter,
  methods: {
    changeUsersFilter () {
      // this.$store.commit('changeUsersFilter')
      this.keyTable++
    },
    editUser () {
      this.keyDialog++
      this.openDialog = 1
    },
    addUser () {
      this.keyCreateUser++
      this.openCreateUser = 1
      this.$store.state.createDialog = 1
    },
    closeUserCreate (flag) {
      this.openDialog = 0
      this.$store.state.editId = null
      if (flag === true) {
        this.keyTable++
      }
    },
    closeEditDialog (flag) {
      this.openDialog = 0
      this.$store.state.editId = null
      if (flag === true) {
        this.keyTable++
      }
    }
  }
}
</script>

<style scoped>

  .ct-green {
    background-color: green !important;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UsersIndex.vue